import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { settingsApi } from "../api/resources.js";
import { useAuthStore } from "../stores/authStore.js";

const ACTIVITY_EVENTS = ["click", "touchstart", "keydown", "mousemove"] as const;

/** 一定時間操作がなければロック画面（PINログイン）へ自動遷移する。 */
export function useAutoLock(): void {
  const navigate = useNavigate();
  const staff = useAuthStore((state) => state.staff);
  const logout = useAuthStore((state) => state.logout);
  const lastActivityRef = useRef(Date.now());
  const autoLockMinutesRef = useRef(5);

  useEffect(() => {
    if (!staff) return;

    settingsApi
      .getPublic()
      .then((res) => {
        autoLockMinutesRef.current = res.autoLockMinutes;
      })
      .catch(() => undefined);

    const markActivity = () => {
      lastActivityRef.current = Date.now();
    };
    ACTIVITY_EVENTS.forEach((eventName) => window.addEventListener(eventName, markActivity));

    const interval = setInterval(() => {
      const idleMs = Date.now() - lastActivityRef.current;
      const limitMs = autoLockMinutesRef.current * 60 * 1000;
      if (idleMs > limitMs) {
        void logout().then(() => navigate("/login", { replace: true }));
      }
    }, 15000);

    return () => {
      ACTIVITY_EVENTS.forEach((eventName) => window.removeEventListener(eventName, markActivity));
      clearInterval(interval);
    };
  }, [staff, navigate, logout]);
}
